import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import en from './locales/en/translation.json';
import ru from './locales/ru/translation.json';
import fr from './locales/fr/translation.json';
import { buildPseudoCatalog } from './pseudoLocale';

export const SUPPORTED_LOCALES = ['en', 'ru', 'fr', 'en-XA'];
export const DEFAULT_LOCALE = 'en';

export function detectInitialLocale() {
    try {
        const navLang = (navigator.language || '').toLowerCase();
        const base = navLang.split('-')[0];
        if (SUPPORTED_LOCALES.includes(base)) return base;
    } catch (_) { /* ignore */ }
    return DEFAULT_LOCALE;
}

i18n
    .use(ICU)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ru: { translation: ru },
            fr: { translation: fr },
            'en-XA': { translation: buildPseudoCatalog(en) }
        },
        lng: detectInitialLocale(),
        fallbackLng: DEFAULT_LOCALE,
        interpolation: { escapeValue: false },
        returnEmptyString: false,
        keySeparator: false,
        nsSeparator: false
    });

export default i18n;
